"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../../schema");
const value = schema_1.Schema.number()
    .expiration(31536000)
    .unit("U/l")
    .integer()
    .min(0)
    .max(99999)
    .interpretation({ vocab: "ktx", code: "lab_ggt" })
    .tag({ vocab: "loinc", code: "2324-2", source: "synonym" })
    .tag({ vocab: "snomed", code: "69480007", source: "synonym" })
    .tag({ vocab: "ktx", code: "lab_procedure" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ value });
